import features from '@save/features';

export type Toggle = {
  name: string;
  enabled: boolean;
  description: string;
};

let toggles: Toggle[];

export const initializeToggles = async (): Promise<void> => {
  setToggles(features?.length ? features : toggles);
};

export const getToggles = (): Toggle[] => toggles;

export function setToggles(data: Toggle[]): void {
  toggles = data;
}

export function isToggleEnabled(toggleName: string): boolean {
  return toggles.find((t) => t.name === toggleName)?.enabled;
}

export enum ToggleName {
  RevealDepartments = 'REVEAL_DEPT_MGMT_PAGE',
  RevealGroups = 'REVEAL_GROUP_MGMT_PAGE',
  RevealReports = 'REVEAL_REPORTS',
  RevealUnsupportedBrowser = 'REVEAL_UNSUPPORTED_BROWSER',
  RevealUserProfile = 'REVEAL_USER_PROFILE',
  RevealAgencyRegistration = 'REVEAL_AGENCY_REGISTRATION',
  RevealUserManagement = 'REVEAL_USER_MGMT_PAGE',
  DisableCreateCaseWithoutTraining = 'DISABLE_CREATE_CASE_WITHOUT_TRAINING',
  EnableLoginDotGov = 'ENABLE_LOGIN_DOT_GOV',
}
